import React, {useState} from 'react';
import './CreationSelector.scss'
import {useGetCreationLabelsQuery, useGetPlaylistsQuery, useGetScreensQuery, useGetTemplatesQuery, useGetTemplatesFromPlaylistUuidQuery, useGetPlaylistsFromScreenUuidQuery,} from "../../../services/api";
import {LabelPicker} from "../../../components/LabelPicker/LabelPicker";
import { useTranslation } from "react-i18next";
import 'react-tooltip/dist/react-tooltip.css'
import {InformationTooltip} from "../../../components/InformationTooltip/InformationTooltip";

export default function CreationSelector({creationType, selectedAspectRatio, selectedCreationIds, handleSelectedCreationsChange, selectionError}) {
    const { t } = useTranslation();

    /* ---- Data fetching ---- */
    const templatesQueryResult = useGetTemplatesQuery({pollingInterval: 3600000});
    const playlistsQueryResult = useGetPlaylistsQuery({pollingInterval: 3600000});
    const screensQueryResult = useGetScreensQuery({pollingInterval: 3600000});
    const labelsQueryResult = useGetCreationLabelsQuery({pollingInterval: 3600000});

    let creationsQueryResult = null;
    if (creationType === 'template') {
        creationsQueryResult = templatesQueryResult;
    } else if (creationType === 'playlist') {
        creationsQueryResult = playlistsQueryResult;
    } else if (creationType === 'screen') {
        creationsQueryResult = screensQueryResult;
    }

    const [searchText, setSearchText] = useState('');
    const handleSearchTextChange = (event) => {
        setSearchText(event.target.value.toLowerCase());
    };

    const [selectedLabels, setSelectedLabels] = useState([]);
    const handleLabelFilterChange = (event) => {
        const selectedLabels = [];
        event.forEach(label => {
            selectedLabels.push(label.id)
        })
        setSelectedLabels(selectedLabels)
    }

    return (
        <div id="selector-container">
            <h3>
                {creationType === 'template' && t('generic.templates') }
                {creationType === 'playlist' && t('generic.playlists') }
                {creationType === 'screen'   && t('generic.screens') }

                <InformationTooltip>
                    {
                        {
                            'template': t('quick_publish.creation_selector.template_info'),
                            'playlist': t('quick_publish.creation_selector.playlist_info'),
                            'screen':   t('quick_publish.creation_selector.screen_info'),
                        }[creationType]
                    }
                </InformationTooltip>
            </h3>

            <input onChange={handleSearchTextChange} value={searchText} id="popup-filter-search" type="search" placeholder={t('generic.searching')} />


            {(labelsQueryResult.isSuccess && labelsQueryResult.data.length !== 0) && (
                <LabelPicker labels={labelsQueryResult.data} onChange={handleLabelFilterChange} placeholder={t('generic.filter_on_labels')} />
            )}

            <div id="popup-selector-content">
                {creationsQueryResult.isFetching && <div>{t('generic.loading')}</div>}
                {creationsQueryResult.isSuccess &&
                    <div className="options-container">
                        {creationsQueryResult.data.map((creation, index) => {
                            let shouldRender = true;

                            // Text search filtering
                            if (searchText.length > 0 && !creation.name.toLowerCase().includes(searchText)) {
                                shouldRender = false;
                            }

                            // Label filtering
                            if (selectedLabels.length > 0) {
                                const filtered = selectedLabels.every(selectedLabel => {
                                    return creation.labels.some(label => label.includes(selectedLabel))
                                });

                                if (!filtered) shouldRender = false;
                            }

                            if (shouldRender) {
                                return (
                                    <label
                                        id={`${creation.id}-option`}
                                        className={`${selectionError ? 'error-option' : ''} option`}
                                        htmlFor={creation.id}
                                        key={index}
                                        // data-tooltip-id={`creation-preview-tooltip-${index}`}
                                        // data-tooltip-html={<CreationTooltipContent creationType={creationType} creationId={creation.id}/>}
                                    >

                                        {/*<Tooltip id="creation-preview-tooltip" float={true} anchorSelect={`#${creation.id}-option`}>*/}
                                        {/*    <CreationTooltipContent creationType={creationType} creation={creation}/>*/}
                                        {/*</Tooltip>*/}

                                        <input
                                            id={creation.id}
                                            type="checkbox"
                                            disabled={typeof selectedAspectRatio === 'string' && typeof creation.aspectRatio === 'string' && creation.aspectRatio !== selectedAspectRatio}
                                            onChange={(e) => handleSelectedCreationsChange(e, creationType, creation.id)}
                                            defaultChecked={selectedCreationIds.includes(creation.id)}
                                        />
                                        <span>{creation.name}</span>
                                    </label>
                                )
                            }
                        })}
                    </div>
                }

                {creationsQueryResult.isError && <div>{creationsQueryResult.error}</div>}
            </div>

            <div id="select-error">
                {(selectionError && creationType === 'template') && t('quick_publish.creation_selector.template_error')}
                {(selectionError && creationType === 'playlist') && t('quick_publish.creation_selector.playlist_error')}
                {(selectionError && creationType === 'screen') && t('quick_publish.creation_selector.screen_error')}
            </div>
        </div>
    )
}


// const CreationTooltipContent = ({creationType, creation}) => {
//     if (creationType === 'template') {
//         return (
//             <div className={'creation-preview-tooltip-content'}>
//                 <div className={'template-preview-image'} style={{backgroundImage: `url(${staticFileBaseUrl}${creation.imagePath})`}}/>
//             </div>
//         )
//     }
//
//     if (creationType === 'playlist') {
//         const playlistTemplatesQueryResult = useGetTemplatesFromPlaylistUuidQuery({id: creation.id}, {pollingInterval: 3600000});
//
//         return (
//             <div className={'creation-preview-tooltip-content'}>
//                 {playlistTemplatesQueryResult.isSuccess && playlistTemplatesQueryResult.data.map((creation, index) => {
//                     return (
//                         <div key={index} className={'template-preview-image'} style={{backgroundImage: `url(${staticFileBaseUrl}${creation.imagePath})`}}/>
//                     )
//                 })}
//             </div>
//         )
//     }
//     if (creationType === 'screen') {
//         const screenPlaylistQueryResult = useGetPlaylistsFromScreenUuidQuery({id: creation.id}, {pollingInterval: 3600000});
//
//         return (
//             <div className={'creation-preview-tooltip-content'}>
//                 <div className={'template-preview-image'} style={{backgroundImage: `url(${staticFileBaseUrl}${creation.imagePath})`}}/>
//             </div>
//         )
//     }


    // return (
    //     <div className={'creation-preview-tooltip-content'}>
    //         {creationType === 'template' &&
    //             <div className={'template-preview-image'} style={{backgroundImage: `url(${staticFileBaseUrl}${creation.imagePath})`}}/>
    //         }
    //         {(creationType === 'playlist' && playlistTemplatesQueryResult.isSuccess) &&
    //             <div className={'template-preview-image'} style={{backgroundImage: `url(${staticFileBaseUrl}${creation.imagePath})`}}/>
    //         }
    //         {/*{creationType === 'screen' &&*/}
    //         {/*    <div className={'template-preview-image'} style={{backgroundImage: `url(${staticFileBaseUrl}${creation.imagePath})`}}/>*/}
    //         {/*}*/}
    //     </div>
    // )
// }
